import { useLocation, Navigate } from "react-router-dom";
import NotFound from "./NotFound";

// Maps legacy /products/*.htm URLs from the previous website to the closest
// relevant page on the new site. Unmatched catalog/faceted pages fall through
// to the noindex 404 so Google drops them.
function resolveTarget(pathname) {
  const p = pathname.toLowerCase();
  const has = (...k) => k.some((x) => p.includes(x));

  if (has("lista-prodotti", "sub-0-")) return null; // faceted catalog junk -> 404/noindex
  if (has("la-spezia")) return "/la-spezia-shore-excursion";
  if (has("cinque-terre")) return "/cinque-terre-private-tour";
  if (has("carrara", "forte-dei-marmi", "-marmi", "marble", "viareggio")) return "/viareggio-carrara-yacht-transfers";
  if (has("airport")) return "/pisa-florence-airport-transfers";
  if (has("piombino", "portofino", "-port", "livorno")) return "/livorno-cruise-transfers";
  if (has("florence", "firenze")) return "/florence-private-tour";
  if (has("siena", "san-gimignano", "val-orcia", "orcia", "montalcino", "montepulciano")) return "/cruise-tours";
  if (has("chianti")) return "/tuscany-wine-tours";
  if (has("transfer", "lucca", "pisa", "garfagnana", "massarosa", "castelnuovo", "volterra", "san-miniato", "montecatini")) return "/private-driver-tuscany";
  return null;
}

export default function LegacyRedirect() {
  const { pathname } = useLocation();
  const target = resolveTarget(pathname);
  if (target) return <Navigate to={target} replace />;
  return <NotFound />;
}
